function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.372 2.759a.45.45 0 000-.629.433.433 0 00-.619 0l-1.44 1.464-.566-.575a.433.433 0 00-.619 0 .45.45 0 000 .629l.875.888c.171.174.448.174.619 0l1.75-1.777zm2.534.13a.662.662 0 00-.656.667c0 .368.294.666.656.666h7.438A.661.661 0 0015 3.556a.662.662 0 00-.656-.667H6.906zm0 4.444A.662.662 0 006.25 8c0 .368.294.667.656.667h7.438A.662.662 0 0015 8a.662.662 0 00-.656-.667H6.906zm-.656 5.111c0-.368.294-.666.656-.666h7.438c.362 0 .656.298.656.666a.662.662 0 01-.656.667H6.906a.662.662 0 01-.656-.667zM4.372 7.648a.45.45 0 000-.629.433.433 0 00-.619 0l-1.44 1.464-.566-.575a.433.433 0 00-.619 0 .45.45 0 000 .628l.875.89c.171.173.448.173.619 0l1.75-1.778zm0 3.816a.45.45 0 010 .628l-1.75 1.778a.433.433 0 01-.619 0l-.875-.89a.45.45 0 010-.628.433.433 0 01.619 0l.565.575 1.441-1.463a.433.433 0 01.619 0z"
});

function SvgResolutionCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgResolutionCategory;